import React, { Component } from "react"
import { Card, CardBody, Col, Label, Input, FormGroup, CardTitle } from "reactstrap"
import {
    createNotificationHelpers,
    updateStoreShopifyPlus,
} from "../utils";

export default class ShopifyPlus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            is_shopify_plus: props.is_shopify_plus || false,
            store_domain: props.store_domain || ''
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    // Update state when props change
    componentDidUpdate(prevProps) {
        if (prevProps.is_shopify_plus !== this.props.is_shopify_plus) {
            this.setState({ is_shopify_plus: this.props.is_shopify_plus });
        }
    }

    /**
     * Handles Shopify Plus checkbox change
     */
    handleChangeCheckbox = async () => {
        const answer = window.confirm("Are you sure you want to change?");
        if (!answer) {
            return;
        }

        const storeData = {
            store_domain: this.props.store_domain,
            is_shopify_plus: !this.state.is_shopify_plus
        };

        const success = await updateStoreShopifyPlus(
            storeData,
            this.notify_success,
            this.notify_error
        );

        if (success) {
            this.setState({ is_shopify_plus: !this.state.is_shopify_plus });
        }
    }
    render() {
        return (
            <React.Fragment>
                <Col xl={3}>
                    <Card className="shadow-sm">
                        <CardBody className="py-4">
                            <CardTitle tag="h6" className="mb-3 text-muted">
                                Shopify Plus
                            </CardTitle>
                            <p className="text-muted small mb-3">
                                Enable if this store is on the Shopify Plus plan.
                            </p>
                            <FormGroup className="form-check form-switch mb-0 d-flex align-items-center justify-content-between py-2 px-3 rounded bg-light">
                                <Label
                                    htmlFor="shopify-plus-switch"
                                    className="form-check-label mb-0 fw-normal"
                                >
                                    Is Shopify Plus
                                </Label>
                                <Input
                                    type="checkbox"
                                    name="is_shopify_plus"
                                    className="form-check-input"
                                    id="shopify-plus-switch"
                                    onChange={this.handleChangeCheckbox}
                                    checked={this.state.is_shopify_plus}
                                />
                            </FormGroup>
                        </CardBody>
                    </Card>
                </Col>
            </React.Fragment>
        )
    }
}